module.exports = __webpack_public_path__ + "static/media/event_fitness.d60c6633.jpg";